import { Card, Timeline } from 'antd'
import { useTranslation } from 'react-i18next'

import type { ReceivedCancellationRequestRoot } from '@repo/sdk'
import { formatKstDateTime } from '../../utils/formatKstDateTime'

interface CancellationTimelineCardProps {
  cancellation: ReceivedCancellationRequestRoot
}

function formatTimestamp(timestamp: string): string {
  return formatKstDateTime(timestamp, 'YYYY-MM-DD HH:mm:ss')
}

export function CancellationTimelineCard({ cancellation }: CancellationTimelineCardProps) {
  const { t } = useTranslation()

  const items = [
    {
      color: 'blue',
      children: `${t('pages.cancellations.fields.requestDateTime')}: ${formatTimestamp(cancellation.requestedAt)}`,
    },
  ]

  if (cancellation.approvedAt) {
    items.push({
      color: 'green',
      children: `${t('common.status.cancellationApproved')}: ${formatTimestamp(cancellation.approvedAt)}`,
    })
  }

  if (cancellation.rejectedAt) {
    items.push({
      color: 'red',
      children: `${t('common.status.cancellationRejected')}: ${formatTimestamp(cancellation.rejectedAt)}`,
    })
  }

  return (
    <Card title={t('pages.cancellations.sections.statusTimeline')} bordered>
      <Timeline items={items} />
    </Card>
  )
}
